// src/pages/Order.js
import React from 'react';
import styled from 'styled-components';
import { useCart } from '../context/CartContext';
import { Link, useNavigate } from 'react-router-dom';

const Page = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
`;
const Header = styled.h2`color:#e1d6c0;margin-bottom:12px;`;
const Table = styled.table`width:100%;border-collapse:collapse;background:rgba(13,13,13,0.8);`;
const Th = styled.th`text-align:left;padding:12px;border-bottom:1px solid #444;color:#e1d6c0;`;
const Td = styled.td`padding:10px 12px;border-bottom:1px dashed #333;color:#fff;`;
const SmallBtn = styled.button`
  background:transparent;color:#e1d6c0;border:1px solid #e1d6c0;
  padding:2px 8px;border-radius:6px;cursor:pointer;margin-left:6px;
`;
const CheckoutBar = styled.div`margin-top:20px;display:flex;justify-content:space-between;align-items:center;`;
const PrimaryBtn = styled.button`
  padding:12px 20px;font-weight:700;border-radius:24px;border:none;background:#e1d6c0;color:#0d0d0d;cursor:pointer;
`;

const formatCents = (cents) => `$${(cents / 100).toFixed(2)}`;

const Order = () => {
  const { items, removeItem, updateQty, clearCart, totalCents } = useCart();
  const navigate = useNavigate();
  const [kitchenOnline, setKitchenOnline] = React.useState(null); // null=unknown, true/false=known

  // Redirect ASAP if kitchen is offline
  React.useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const r = await fetch('/api/kitchen/health', { cache: 'no-store' });
        if (!r.ok) throw new Error('bad status');
        const d = await r.json();
        if (cancelled) return;
        if (!d.online) return navigate('/technicalerror', { replace: true });
        setKitchenOnline(true);
      } catch {
        if (cancelled) return;
        // On error, treat as offline for safety
        navigate('/technicalerror', { replace: true });
      }
    };

    check();
    return () => { cancelled = true; };
  }, [navigate]);

  const checkout = async () => {
    if (!items.length) return;

    // Double-check before letting them proceed
    try {
      const r = await fetch('/api/kitchen/health', { cache: 'no-store' });
      const d = r.ok ? await r.json() : { online: false };
      if (!d.online) return navigate('/technicalerror');
    } catch {
      return navigate('/technicalerror');
    }

    navigate('/checkout'); // new flow
  };

  return (
    <Page>
      <Header>Your Order</Header>

      {items.length === 0 ? (
        <div style={{ color: '#fff' }}>
          Your cart is empty. <Link to="/menu">Browse the Menu</Link>
        </div>
      ) : (
        <>
          <Table>
            <thead>
              <tr>
                <Th>Item</Th>
                <Th>Qty</Th>
                <Th>Price</Th>
                <Th></Th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.id}>
                  <Td>{i.name}</Td>
                  <Td>
                    <SmallBtn onClick={() => updateQty(i.id, i.quantity - 1)}>-</SmallBtn>
                    <span style={{ margin: '0 8px' }}>{i.quantity}</span>
                    <SmallBtn onClick={() => updateQty(i.id, i.quantity + 1)}>+</SmallBtn>
                  </Td>
                  <Td>{formatCents(i.unitAmount * i.quantity)}</Td>
                  <Td>
                    <SmallBtn onClick={() => removeItem(i.id)}>Remove</SmallBtn>
                  </Td>
                </tr>
              ))}
            </tbody>
          </Table>

          <CheckoutBar>
            <div style={{ color: '#e1d6c0' }}>Total: {formatCents(totalCents)}</div>
            <div>
              <SmallBtn onClick={clearCart}>Clear</SmallBtn>
              <PrimaryBtn style={{ marginLeft: 12 }} onClick={checkout}>
                Continue
              </PrimaryBtn>
            </div>
          </CheckoutBar>

          <div style={{ marginTop: 14 }}>
            <Link to="/menu">
              <SmallBtn>← Back to Menu</SmallBtn>
            </Link>
          </div>
        </>
      )}
    </Page>
  );
};

export default Order;


// const stripecheckout = async () => {
//   if (!items.length) return;
//   setLoading(true);
//   try {
//     console.log('Starting checkout with items:', items);
//     if (!publishableKey) throw new Error('Stripe publishable key is missing');
//     if (!window.Stripe) throw new Error('Stripe.js not loaded');
//     const res = await fetch('/api/create-checkout-session', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         items: items.map((i) => ({
//           name: i.name,
//           quantity: i.quantity,
//           unit_amount: i.unitAmount,
//         })),
//       }),
//     });
//     const data = await res.json();
//     if (!res.ok) {
//       console.error('Checkout session creation failed:', data);
//       throw new Error(data.message || 'Failed to start checkout');
//     }
//     const stripe = window.Stripe(publishableKey);
//     const result = await stripe.redirectToCheckout({ sessionId: data.sessionId });
//     if (result && result.error) {
//       throw new Error(result.error.message || 'Checkout failed');
//     }
//   } catch (e) {
//     console.error('Checkout error:', e);
//     setError(e.message);
//     setLoading(false);
//   }
// };